var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Absolute2DPosition, SerializableMember, SerializableObject } from '@openhps/core';
let AbstractLocation = class AbstractLocation extends Absolute2DPosition {
    constructor(uid, range = 1000) {
        super();
        this._uid = uid;
        const hashX = this.hashCode(uid + 'x' + range);
        const hashY = this.hashCode(uid + 'y' + range * 2);
        const angleX = ((hashX % 360) + 45) * (Math.PI / 180);
        const angleY = ((hashY % 360) + 90) * (Math.PI / 180);
        const radiusX = ((hashX % range) + 1) * 0.9;
        const radiusY = ((hashY % range) + 1) * 1.1;
        this.x = Math.cos(angleX) * radiusX;
        this.y = Math.sin(angleY) * radiusY;
    }
    get uid() {
        return this._uid;
    }
    hashCode(str) {
        str = str.toLowerCase();
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = Math.imul(hash ^ char, 2654435761);
            hash = (hash << 13) | (hash >>> 19);
        }
        return Math.abs(hash);
    }
};
__decorate([
    SerializableMember({
        name: 'uid',
    }),
    __metadata("design:type", String)
], AbstractLocation.prototype, "_uid", void 0);
AbstractLocation = __decorate([
    SerializableObject(),
    __metadata("design:paramtypes", [String, Number])
], AbstractLocation);
export { AbstractLocation };
//# sourceMappingURL=AbstractLocation.js.map